import {EventEmitter, InjectionToken} from '@angular/core';
import {SignInData} from '../../models/msal/sign-in-data.model';
import {AzureSignInMethodEnum} from '../../enums/azure-sign-in-method.enum';

export interface AzureService {
    readonly onSignIn: EventEmitter<SignInData>;
    readonly onSilentSignIn: EventEmitter<SignInData | undefined>;
    readonly onSignInFailure: EventEmitter<AzureSignInMethodEnum>;

    setup(): Promise<void>;

    login(): Promise<void>;

    logout(): Promise<void>;

    tryToReLogin(): Promise<boolean>;
}

export const AZURE_SERVICE = new InjectionToken<AzureService>('AzureService');
